window.addEventListener('DOMContentLoaded', () => {
  const inquiryButton = document.getElementById('inquiry-button');

  inquiryButton.addEventListener('click', () => {
    const productTitle = document.getElementById('inquiry-button-title').value;
    const se = document.getElementById('se').value;

    const subject = `${atob(productTitle)} - Mogul`;

    window.location.assign(`mailto:${atob(se)}?subject=${subject}`);
  });
});
